export default __webpack_public_path__ + "static/media/seademo_consorzio.a9b9d159.png";